import { render, staticRenderFns } from "./VendorSelect.vue?vue&type=template&id=0ccb707e"
import script from "./VendorSelect.vue?vue&type=script&lang=js"
export * from "./VendorSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1708263617/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ccb707e')) {
      api.createRecord('0ccb707e', component.options)
    } else {
      api.reload('0ccb707e', component.options)
    }
    module.hot.accept("./VendorSelect.vue?vue&type=template&id=0ccb707e", function () {
      api.rerender('0ccb707e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/promotions/VendorSelect.vue"
export default component.exports